// Company links, loaded once and shared by the navigation, launcher, home page and the Company links page.
import { useSyncExternalStore } from "react";
import { api, type CompanyLink } from "./api";

let links: CompanyLink[] = [];
let loaded = false;
const subs = new Set<() => void>();
const emit = () => subs.forEach((f) => f());

export async function reloadLinks() {
  try { links = await api.links(); } catch { /* signed out or offline: keep what we have */ }
  loaded = true; emit();
}

export function useCompanyLinks() {
  const snap = useSyncExternalStore((f) => { subs.add(f); if (!loaded) { loaded = true; void reloadLinks(); } return () => subs.delete(f); }, () => links);
  return snap;
}

export const linksFor = (all: CompanyLink[], area: string) => all.filter((l) => l.area === area);
